/*
 * qty-drawer.js: the quantity drawer (Round 6 Q01, storefront #49), phones and tablets (<= 1024 px).
 * Markup and data: snippets/qty-drawer.liquid (<sofsy-qty-drawer>, rendered inside the product section).
 * Styles: .qd in assets/sofsy-pdp.css. Tokens: assets/sofsy-ds.css.
 *
 * What opens it (BUILD_MAP P13, P15, P20)
 * - The page's Add to Bag and the sticky Add to Bag. One CAPTURE-phase click listener on document, at <= 1024 px:
 *   preventDefault() + stopPropagation(), then open(). A tap never submits <product-form>, so there is never an add
 *   on that tap (0 /cart/add requests) and never a second handler (TRACKING §3 P13). Also when the button is disabled
 *   (a shade sold out in every size, Q-18): a disabled button lets the tap through to its container, which is inside
 *   .product-form__buttons.main, so the same listener opens the drawer instead of bundle.js's old size sheet.
 *   Above 1024 px nothing is intercepted: desktop adds through <product-form> exactly as today.
 *   If this file never loads, nothing is intercepted either, and the buttons add through <product-form> as today.
 * - SR-2 (self-review, 2 Oct): when the drawer would have NOTHING to offer (her shade sold out in every size and no
 *   other shade it can show has stock: Liquid `pdp_notify_only`, sections/main-product.liquid, which marks the buttons'
 *   container [data-pdp-notify] and labels them "Notify me"), the same tap opens the notify sheet for her shade in her
 *   size instead (SofsyNotify.open, assets/notify-me.js), the variant her own G0 row would subscribe. Still never a
 *   submit. The drawer is not opened, so the page never shows a drawer whose only row is sold out.
 * - The Complete the Set line under the price ([data-cts-link="page"]): opens on the set, every in-stock set shade at 1.
 *
 * Ben's Round 6 picks (drawer.json Q01 F0 with L1, SR2, G0, W3, OH; his words override the card)
 * - L1 + the P20 note: row 1 is the delivery line (US only) and the X; Complete the Set sits top left, above the first
 *   shade row, fixed; the totals sit right in the fixed bottom, over Add to Bag.
 * - OH: her shade first, then the style's colour list; shades sold out in their size last, in list order. Opened from
 *   the page's line: the set first (set order), then her shade, then the list. Her own row never moves to the end:
 *   when her shade is sold out in every size (Q-18) it still opens first, in G0 with "Notify me" in view.
 * - SR2: the size and its chevron are one button; it opens the bag's 30 px pills INSIDE the row, LEFT-ALIGNED under
 *   the size (Ben); one tap changes that row only; the rows below slide down while the pills are open.
 * - G0: a shade sold out in its size sits last (hers excepted, above), its name and size grey, − 0 + all light grey in the stepper's box, no
 *   diagonal; plus a grey underlined small "Notify me" that opens the notify sheet for THAT row's variant (Ben). Its
 *   size button stays live (Q-19): picking a size in stock ungreys the row in place, without moving it.
 * - Complete the Set (W3 look) sets every in-stock set shade that is at 0 to 1, and changes nothing else (#63 A7,
 *   Ben MC-28/R12: Black 2 / Red 2 / White 0 → White 1 only); rows that are not in the set are left alone (Q-3). It then fades out in place (its space is kept) and comes back when an
 *   in-stock set shade is at 0 again.
 * - S40 steppers: − grey at 0 and on the last pair left (the drawer never empties); + grey at the row's cap: min(stock, 15,
 *   the bag's per-line cap) minus what is already in the bag. No cap across shades (#63, Ben 3 Oct: 10 per product was
 *   too low); the pooled price stops at the ladder's last rung (rungAt).
 * - H5: 5½ rows in view, then the list scrolls; if the sheet would pass 80 % of the visible height, one whole row
 *   fewer at a time, so half a row always shows.
 * - Motion: sheet 200 ms cubic-bezier(.2,0,0,1) in, 160 ms ease-in out, the dim 0 → .4; a stepper value crossfades
 *   100 ms; Complete the Set changes rows 40 ms apart, top to bottom; totals and the delivery line crossfade 150 ms,
 *   OPACITY ONLY (Ben: "nothing else on the page should move around"); the link fades 150 ms in place; the scroll
 *   hairline fades 150 ms. prefers-reduced-motion: opacity only, 100 ms at most.
 *
 * Figures (never typed; a projection, the bag shows what Shopify charges)
 * - The Indulgence Privilege as SupaEasy applies it (PRICING_AND_DISCOUNTS "How the ladder works"): units in the four
 *   ladder families POOL across the whole bag (rule A), the gate needs 2 tagged units (rule B), and each line gets its
 *   own family's amount off each unit: its ladder's qty_01 − qty_P (P = pooled units, capped at the ladder's 10 rungs).
 *   The drawer's pairs are pooled with the ladder units already in the bag (from #bag-state, C3.6, which every cart
 *   write refreshes, re-checked against GET /cart.js on each open).
 * - Outside the US the same privilege is taken in the page's own price basis: a pair is the variant's price ×
 *   qty_P / qty_01 (Q-21 as amended by the s06 review, S2; the page's privilege panel uses the same rule). Where the
 *   page shows US prices this is the US figure to the cent; in Great Britain, whose pages add 20 % (65 → 78), it is
 *   the US figure × 1.2 (2 pairs 132), the basis the page and, most likely, checkout use. A plain US-dollar
 *   subtraction (78 − 10 = 68) matched nothing Shopify charges. The bag's own GB figure is zao#190.
 * - The delivery line (US only): threshold − her whole bag after the privilege WITH the drawer's pairs added; blank
 *   (its space kept) while the drawer holds no pair.
 *
 * The add (BUILD_MAP C2.3): the button is type="button", outside <product-form>; one tap calls
 * cartItems.addItems(rows above 0, {source: 'drawer' | 'cts_line'}): ONE POST /cart/add.js with every row, the marker
 * and _previousBonusPercentage. Disabled while it runs (no double add).
 * zao#617 (Ben, 5 Oct): the bag opens AT ONCE. The tap draws the rows into the bag as pending lines
 * (cartItems.beginPendingAdd), closes the drawer and opens the bag (viewDrawer), then sends the same one add; Shopify's
 * answer settles the bag (endPendingAdd: the real lines on success; on a refusal the pending lines go and Shopify's
 * sentence shows in the bag and, as before, on the page). qd.close waits for the answer (settleOpenAdd). With a cart.js
 * that cannot draw pending lines, the add runs as it did before this change: on success the drawer closes, then the
 * bag opens once (viewDrawer). On a refusal: Shopify's sentence shows above the button, the button comes back, and the
 * page's .product-form__error-message-wrapper is unhidden with the same words, so Clarity's add_to_cart_failed keeps
 * counting (assets/clarity-tagging.js). A refusal that still changed the bag (Shopify adds what stock allows and
 * answers 422) closes the drawer and opens the bag, so she sees what is really in it.
 *
 * Accessibility: role=dialog, aria-modal, named; focus moves in and returns to the opener; Tab stays inside; Escape,
 * the X, the dim and the phone's Back close it (a history entry while open, removed on every other close); one polite
 * status line announces each change; every target 44 px or more.
 *
 * Tracking: through window.sofsyTrack (assets/sofsy-track.js; the event dictionary's names): qty_drawer_opened
 * {source: atb | sticky | cts}, sticky_atc_tapped, complete_set_line_tapped {place: 'pdp'}, complete_set_drawer_tapped
 * {place: 'drawer'}, drawer_size_tapped {shade, size}, drawer_notify_tapped {shade, size} (also the page's "Notify me"
 * in SR-2's notify-only state, with the same payload as her row's link: no new name), size_selected {size,
 * variant_id, in_stock, place: 'drawer', changed_from_default} on a pill tap, and quantity_rung_selected {pairs,
 * rung_price, saving_per_pair, family} 600 ms after the last stepper tap when the pooled pairs moved onto another
 * Indulgence Privilege rung. The add itself is reported by assets/cart.js (bag_items_added, Klaviyo "Added to Cart"
 * in sofsy-track.js). Clarity's add_to_cart_clicked is the drawer's Add to Bag (clarity-tagging.js).
 * Taxonomy v2.0 r6.1 adds qd.close {how, added, shades, units, last_action} once per open and qd.error.view {reason}
 * once per distinct reason per open (trackClose, showError).
 * zao#617: a drawer closed by its Add tap sends qd.close when Shopify answers: how 'added' (worked, or partly kept),
 * or how 'add_failed' with added:false (a full refusal; new value).
 *
 * Never give this script the script-reload class: it binds once on document and survives every colour swap.
 */
(() => {
  'use strict';

  if (window.SofsyQtyDrawer) return;

  const MQ = window.matchMedia('(max-width: 1024px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const NBSP = ' ';
  const RUNG_DEBOUNCE_MS = 600; // quantity_rung_selected waits this long after the last stepper tap
  const HISTORY_KEY = 'sofsyQtyDrawer';

  /* ---------- small helpers ---------- */

  // #63 low_stock_shown: the drawer variants already reported in this page view (survives a colour swap: module scope).
  const lowStockSeen = new Set();

  const track = (name, props) => {
    try {
      if (typeof window.sofsyTrack === 'function') window.sofsyTrack(name, props || {});
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  const parse = (text) => {
    try {
      return text ? JSON.parse(text) : null;
    } catch (_) {
      return null;
    }
  };

  const esc = (value) =>
    String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // Locale templates carry %name% placeholders (snippets/qty-drawer.liquid passes them through the t filter).
  const fill = (template, values) =>
    String(template || '').replace(/%(\w+)%/g, (match, key) => (Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match));

  // A CSS time token in ms ("150ms", "1.2s"); the fallback when it is missing.
  const tokenMs = (name, fallback) => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const number = parseFloat(raw);
    if (!Number.isFinite(number)) return fallback;
    return /ms$/.test(raw) ? number : /s$/.test(raw) ? number * 1000 : number;
  };
  const motion = (ms) => (REDUCED.matches ? Math.min(ms, 100) : ms);

  const cartItems = () => document.querySelector('cart-items');

  const readBag = () => {
    const ci = cartItems();
    if (ci && typeof ci.readBagState === 'function') return ci.readBagState();
    const el = document.getElementById('bag-state');
    return el ? parse(el.textContent) : null;
  };

  // Shopify's money formats ("{{amount_no_decimals}} USD"), so no script types a currency (#43).
  function formatMoney(cents, format) {
    const value = Math.round(Number(cents) || 0);
    const group = (amount, decimals, thousands, decimal) => {
      const fixed = (amount / 100).toFixed(decimals);
      const [whole, fraction] = fixed.split('.');
      const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${withThousands}${decimal}${fraction}` : withThousands;
    };
    const template = typeof format === 'string' && format ? format : '{{amount}}';
    return template.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return group(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return group(value, 2, "'", '.');
        case 'amount_with_period_and_space_separator':
          return group(value, 2, ' ', '.');
        case 'amount_with_space_separator':
          return group(value, 2, ' ', ',');
        default:
          return group(value, 2, ',', '.');
      }
    });
  }

  // "$15": the distance to complimentary delivery, written the way the bag and the drawer write it (US only, R02).
  function distance(cents, currency) {
    const amount = Math.max(0, Number(cents) || 0) / 100;
    const whole = Number.isInteger(Math.round(amount * 100) / 100) && Math.round(amount * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(amount);
    } catch (_) {
      return amount.toFixed(whole ? 0 : 2);
    }
  }

  // A ladder as [qty_01 … qty_10] in whole currency units, from the drawer's own data (an array) or the bag state
  // (the metaobject printed as JSON: an object of qty_NN fields, possibly with {value}).
  function ladderArray(raw) {
    if (Array.isArray(raw)) return raw.map((n) => (n == null || n === '' ? null : Number(n)));
    if (!raw || typeof raw !== 'object') return null;
    const out = [];
    for (let n = 1; n <= 10; n += 1) {
      const key = n < 10 ? `qty_0${n}` : `qty_${n}`;
      let v = raw[key];
      if (v && typeof v === 'object' && 'value' in v) v = v.value;
      out.push(v == null || v === '' || !Number.isFinite(Number(v)) ? null : Number(v));
    }
    return out.some((n) => n != null) ? out : null;
  }

  // The ladder's rung at P pooled units (capped at the last rung with a figure), or null below 2 or without a ladder.
  function rungAt(ladder, pooled) {
    if (!ladder || ladder[0] == null || pooled < 2) return null;
    let rung = null;
    for (let i = Math.min(pooled, ladder.length) - 1; i >= 0 && rung == null; i -= 1) rung = ladder[i];
    return rung;
  }

  // US: the amount off each unit, in cents, at P pooled units: SupaEasy's fixed amount (qty_01 − qty_P dollars).
  function rungOff(ladder, pooled) {
    const rung = rungAt(ladder, pooled);
    if (rung == null) return 0;
    return Math.max(0, Math.round((ladder[0] - rung) * 100));
  }

  // Outside the US: the share of the page's price each unit costs at P pooled units (qty_P / qty_01), so the same
  // fixed amount is taken off in the page's own price basis. Where the page shows the US price (every country but
  // Great Britain; each colour's price equals its ladder's qty_01 on 348 of 348 active variants, Admin API, 2 Oct)
  // this is exactly the US amount; in GB, where the page adds 20 % (65 → 78), it is the US figure × 1.2
  // (2 pairs 132, not 78 − 10 = 68 × 2 = 136; s06 review S2, zao#190).
  function rungShare(ladder, pooled) {
    const rung = rungAt(ladder, pooled);
    if (rung == null || !(ladder[0] > 0)) return 1;
    return Math.min(1, Math.max(0, rung / ladder[0]));
  }

  /* ---------- the drawer element ---------- */

  let pendingBack = false; // a history.back() we started, whose popstate has not arrived yet
  let backTimer = 0;

  class SofsyQtyDrawer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = parse(this.querySelector('script[data-qd-data]')?.textContent);
      this.sheet = this.querySelector('[data-qd-sheet]');
      this.list = this.querySelector('[data-qd-list]');
      this.deliveryEl = this.querySelector('[data-qd-delivery]');
      this.ctsSlot = this.querySelector('[data-qd-cts-slot]');
      this.ctsLink = this.querySelector('[data-cts-link="drawer"]');
      this.totalEl = this.querySelector('[data-qd-total]');
      this.perEl = this.querySelector('[data-qd-per]');
      this.withBagEl = this.querySelector('[data-qd-with-bag]');
      this.errorEl = this.querySelector('[data-qd-error]');
      this.addButton = this.querySelector('[data-qd-add]');
      this.liveEl = this.querySelector('[data-qd-live]');
      this.scrollLine = this.querySelector('[data-qd-scroll-line]');
      this.isOpen = false;
      this.busy = false;
      this.saved = null; // her choices between opens: Map shade id → {size, custom, qty}
      this.rows = [];

      if (this.data) {
        this.data.shades = Array.isArray(this.data.shades) ? this.data.shades : [];
        this.data.shades.forEach((shade, index) => {
          shade.listIndex = index;
        });
        const ladders = {};
        Object.keys(this.data.ladders || {}).forEach((handle) => {
          ladders[handle] = ladderArray(this.data.ladders[handle]);
        });
        this.ladders = ladders;
      }

      this.addEventListener('click', (event) => this.onClick(event));
      this.list?.addEventListener('scroll', () => this.scrollLine?.classList.toggle('is-on', this.list.scrollTop > 0), { passive: true });
    }

    disconnectedCallback() {
      // A colour swap replaces the section with this element in it: never leave the page locked.
      if (this.isOpen) {
        this.isOpen = false;
        releaseLock();
      }
    }

    get strings() {
      return (this.data && this.data.strings) || {};
    }

    /* ----- data helpers ----- */

    her() {
      return this.data.shades.find((shade) => shade.id === this.data.product_id) || this.data.shades[0] || null;
    }

    variantOf(shade, size) {
      return shade.variants.find((v) => v.size === size) || null;
    }

    // Her size: the page's chosen size (assets/sofsy-pdp.js reads the checked variant-radios input); when nothing is
    // chosen (every size sold out) the section's default; else the first size.
    herSize() {
      const her = this.her();
      if (!her) return '';
      const state = window.SofsyPdp && typeof window.SofsyPdp.state === 'function' ? window.SofsyPdp.state() : null;
      if (state) {
        const byId = her.variants.find((v) => String(v.id) === String(state.variantId));
        if (byId) return byId.size;
        const bySize = her.variants.find((v) => v.size === state.size);
        if (bySize) return bySize.size;
      }
      const fallback = her.variants.find((v) => v.id === this.data.default_variant_id) || her.variants[0];
      return fallback ? fallback.size : '';
    }

    bagQty(variantId) {
      const lines = (this.bag && Array.isArray(this.bag.lines) && this.bag.lines) || [];
      return lines.reduce((sum, line) => sum + (Number(line.variant_id) === Number(variantId) ? Number(line.quantity) || 0 : 0), 0);
    }

    // What one row may hold: the variant's most (Liquid's min(stock, settings.max_quantity 15), the bag's per-line cap;
    // 0 when unavailable) minus what the bag already holds. No total across rows (#63, Ben 3 Oct).
    cap(row) {
      const v = row.variant;
      if (!v || !v.available) return 0;
      return Math.max(0, (Number(v.max) || 0) - this.bagQty(v.id));
    }

    soldOut(row) {
      return !row.variant || !row.variant.available || !(Number(row.variant.max) > 0);
    }

    total(rows = this.rows) {
      return rows.reduce((sum, row) => sum + row.qty, 0);
    }

    setHandles() {
      return (this.data.set && Array.isArray(this.data.set.handles) && this.data.set.handles) || [];
    }

    isSetRow(row) {
      return this.setHandles().includes(row.shade.handle);
    }

    inStockSetRows() {
      return this.rows.filter((row) => this.isSetRow(row) && !this.soldOut(row) && this.cap(row) >= 1);
    }

    // #63 low-stock line: the row's size has 1 to the threshold units left (Liquid's variant.inventory_quantity, as
    // `left` on each variant, snippets/qty-drawer-shade.liquid; null when Shopify does not track and deny). 0: none.
    lowStock(row) {
      const cfg = this.data && this.data.low_stock;
      if (!cfg || !cfg.on || !row.variant) return 0;
      const left = Number(row.variant.left);
      return Number.isFinite(left) && left >= 1 && left <= (Number(cfg.threshold) || 5) ? left : 0;
    }

    // low_stock_shown {place: 'drawer', n, variant_id}, once per variant per page view.
    noteLowStock(row, left) {
      const id = row.variant && row.variant.id;
      if (!id || lowStockSeen.has(id)) return;
      lowStockSeen.add(id);
      track('low_stock_shown', { place: 'drawer', n: left, variant_id: id, product_id: row.shade.id });
    }

    // #63 (Ben, 3 Oct): a set shade is "in the bag" when ANY line of that product is in the bag, at any size and any
    // quantity (the bag's own state, read at open). Complete the Set only ever offers the shades that are not.
    inBag(row) {
      const lines = (this.bag && Array.isArray(this.bag.lines) && this.bag.lines) || [];
      return lines.some((line) => String(line.product_id) === String(row.shade.id));
    }

    missingSetRows() {
      return this.inStockSetRows().filter((row) => !this.inBag(row));
    }

    /* ----- #63 A9: her drawer survives a colour change and a reload (default, Ben's chat 3 Oct) -----
     * Her last choices (every row's size and quantity, Complete the Set's included) are kept in this tab's
     * sessionStorage per STYLE (the set of shade ids), so changing colour on the page, which replaces this element
     * with the new shade's, or reloading, reopens the drawer as she left it. A successful add clears it (the next
     * open starts fresh: her shade at the default). Kept 30 minutes. Storage blocked: in memory, as before. */
    savedKey() {
      const ids = ((this.data && this.data.shades) || []).map((shade) => shade.id).sort((a, b) => a - b);
      return ids.length ? `sofsy:qd-saved:${ids.join(',')}` : null;
    }

    storeSaved() {
      const key = this.savedKey();
      if (!key) return;
      try {
        if (!this.saved) window.sessionStorage.removeItem(key);
        else window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), rows: [...this.saved.entries()] }));
      } catch (_) {
        /* storage blocked: memory only */
      }
    }

    loadSaved() {
      const key = this.savedKey();
      if (!key) return null;
      try {
        const stored = JSON.parse(window.sessionStorage.getItem(key) || 'null');
        if (!stored || !Array.isArray(stored.rows) || Date.now() - Number(stored.t) > 1800000) return null;
        return new Map(stored.rows);
      } catch (_) {
        return null;
      }
    }

    /* ----- building the rows (OH, SR2 sizes kept between opens, Q-20) ----- */

    buildRows(from) {
      const her = this.her();
      const size = this.herSize();
      if (!this.saved) this.saved = this.loadSaved();
      const saved = this.saved;
      const rows = [];
      this.data.shades.forEach((shade) => {
        const kept = saved && saved.get(shade.id);
        const rowSize = kept && kept.custom ? kept.size : size;
        let variant = this.variantOf(shade, rowSize);
        if (!variant && shade === her) variant = shade.variants[0] || null;
        if (!variant) return; // no such size on this shade (Q-20: hidden, as the page hides what it cannot show)
        rows.push({ shade, size: variant.size, variant, custom: !!(kept && kept.custom), qty: kept ? kept.qty : 0 });
      });

      // OH: her shade first, then the style's list; from the page's line the set first, in set order. Shades sold out
      // in their size go last, in list order, EXCEPT hers: she tapped from her shade's page, so its row keeps its place
      // even when it is sold out (Q-18: "her row in G0 + Notify me"), first from Add to Bag, in the set's order from
      // the line. Without this a sold-out shade on a long style (Angel-Vegas Ice Blue, 19 rows) opened as row 17,
      // below the fold, with her "Notify me" reachable only by scrolling (s06 review S1).
      const order = [];
      const add = (row) => {
        if (row && !order.includes(row)) order.push(row);
      };
      if (from === 'cts') {
        this.setHandles().forEach((handle) => add(rows.find((row) => row.shade.handle === handle)));
      }
      const herRow = rows.find((row) => row.shade === her) || null;
      add(herRow);
      rows.forEach(add);
      const stays = (row) => row === herRow || !this.soldOut(row);
      const inStock = order.filter(stays);
      const out = order.filter((row) => !stays(row)).sort((a, b) => a.shade.listIndex - b.shade.listIndex);
      this.rows = inStock.concat(out);

      this.rows.forEach((row) => {
        row.qty = Math.min(row.qty, this.cap(row));
      });

      if (from === 'cts') {
        // Opened from the page's line (XA): every in-stock set shade at 0 goes to 1; anything else she chose stays.
        this.applyCts();
      } else if (this.total() === 0) {
        // From Add to Bag: her shade at the style's default (pp_default_qty; 2 on 78 of 83 colours), the rest at 0.
        // Her earlier choices are kept between opens (and on a size change on the page); only an empty drawer resets.
        if (herRow) herRow.qty = Math.min(Number(this.data.default_qty) || 1, this.cap(herRow));
      }
    }

    // #63 A7 (Ben MC-28/R12): "Only quantities at 0 change to 1. Any other quantity doesn't change." Rows outside the
    // set are left alone (Q-3), and so are set shades already in the bag (#63, Ben 3 Oct). Returns the rows whose
    // quantity changed, in display order.
    applyCts() {
      const changed = [];
      this.missingSetRows().forEach((row) => {
        if (row.qty === 0) {
          row.prev = row.qty;
          row.qty = 1;
          changed.push(row);
        }
      });
      return changed;
    }

    // Shown while an in-stock set shade that is not in the bag is at 0 (Q-3, A1's rule; #63 Ben 3 Oct: a shade already
    // in the bag, any size, is never offered again). The old "and the result stays at 10 pairs or fewer" went with the
    // 10-pair total (#63, 3 Oct); each set row it would raise to 1 already has room (inStockSetRows: cap >= 1).
    ctsAvailable() {
      const set = this.missingSetRows();
      return !!this.ctsSlotOn && set.some((row) => row.qty === 0);
    }

    /* ----- figures: the projection (see the header) ----- */

    project() {
      const bag = this.bag || {};
      const lines = Array.isArray(bag.lines) ? bag.lines : [];
      const bagLadders = {};
      Object.keys(bag.ladders || {}).forEach((handle) => {
        bagLadders[handle] = ladderArray(bag.ladders[handle]);
      });
      const ladderFor = (handle) => (handle && (this.ladders[handle] || bagLadders[handle])) || null;

      const drawerRows = this.rows.filter((row) => row.qty > 0);
      const bagUnits = lines.reduce((sum, line) => sum + (line.ladder_unit ? Number(line.quantity) || 0 : 0), 0);
      const drawerUnits = drawerRows.reduce((sum, row) => sum + (row.shade.unit ? row.qty : 0), 0);
      const pooled = bagUnits + drawerUnits;
      const gate =
        lines.reduce((sum, line) => sum + (line.privilege_eligible ? Number(line.quantity) || 0 : 0), 0) +
        drawerRows.reduce((sum, row) => sum + (row.shade.eligible ? row.qty : 0), 0);
      const qualifies = pooled >= 2 && gate >= 2;
      const isUs = bag.is_us != null ? !!bag.is_us : !!this.data.is_us;
      const unitPrice = (price, handle, isUnit) => {
        if (!(isUnit && qualifies)) return price;
        const ladder = ladderFor(handle);
        if (isUs) return Math.max(0, price - rungOff(ladder, pooled));
        return Math.max(0, Math.round(price * rungShare(ladder, pooled)));
      };

      const pairs = this.total();
      const drawerTotal = drawerRows.reduce((sum, row) => sum + row.qty * unitPrice(Number(row.variant.price) || 0, row.shade.ladder, row.shade.unit), 0);
      const bagTotal = lines.reduce((sum, line) => {
        const qty = Number(line.quantity) || 0;
        if (line.ladder_unit && line.original_price != null) return sum + qty * unitPrice(Number(line.original_price) || 0, line.ladder_handle, true);
        return sum + (Number(line.final_line_price) || 0);
      }, 0);

      const threshold = bag.threshold != null ? Number(bag.threshold) : this.data.threshold != null ? Number(this.data.threshold) : null;
      return {
        pairs,
        pooled,
        qualifies,
        total: drawerTotal,
        // #78 (Ben): the grey price per pair from the first pair, so 1 pair reads "65 USD /pair" under 65 USD; it was
        // shown only from 2 pairs (counting ladder pairs already in the bag). Blank at 0 pairs, as before (MC-24).
        perPair: pairs > 0 ? Math.round(drawerTotal / pairs) : null,
        isUs,
        // No delivery line while the drawer holds nothing to add (Q-18: her shade sold out, every row at 0; or the bag
        // already holds all the stock): row 1 keeps its height and the line fades in with her first pair.
        gap: isUs && threshold != null && pairs > 0 ? threshold - (bagTotal + drawerTotal) : null,
        currency: bag.currency || this.data.currency || 'USD',
      };
    }

    money(cents) {
      return formatMoney(cents, this.data.money_format).replace(/ /g, NBSP);
    }

    deliveryHTML(p) {
      if (!p.isUs || p.gap == null) return '';
      const s = this.strings;
      if (p.gap > 0) {
        const parts = String(s.delivery_gap || '%amount%').split('%amount%');
        return `${esc(parts[0])}<span class="qd__gap">${esc(distance(p.gap, p.currency))}</span>${esc(parts.slice(1).join(''))}`;
      }
      const tick = this.querySelector('template[data-qd-tick]')?.innerHTML || '';
      return `<span class="qd__reached">${tick}<span>${esc(s.delivery_reached || '')}</span></span>`;
    }

    deliveryText(p) {
      if (!p.isUs || p.gap == null) return '';
      return p.gap > 0 ? fill(this.strings.delivery_gap, { amount: distance(p.gap, p.currency) }) : this.strings.delivery_reached || '';
    }

    perText(p) {
      if (p.perPair == null) return NBSP;
      return fill(this.data.pair ? this.strings.per_pair : this.strings.per_piece, { price: this.money(p.perPair) });
    }

    countText(n) {
      const s = this.strings;
      const key = this.data.pair ? (n === 1 ? 'count_one' : 'count_other') : n === 1 ? 'piece_one' : 'piece_other';
      return fill(s[key], { n });
    }

    /* ----- rendering ----- */

    rowLabel(row) {
      if (this.soldOut(row)) return fill(this.strings.row_sold, { shade: row.shade.name, size: row.size });
      return fill(this.strings.row, { shade: row.shade.name, count: this.countText(row.qty), size: row.size });
    }

    stepperState(row) {
      const total = this.total();
      const sold = this.soldOut(row);
      return {
        minusOff: sold || row.qty <= 0 || total <= 1,
        plusOff: sold || row.qty >= this.cap(row),
      };
    }

    rowHTML(row, index) {
      const s = this.strings;
      const shade = row.shade;
      const sold = this.soldOut(row);
      const several = shade.variants.length > 1;
      const word = this.data.pair ? 'pair' : 'piece';
      const st = this.stepperState(row);
      const swatch = shade.swatch
        ? `<span class="ds-swatch${shade.edge ? ' ds-swatch--light' : ''}" style="--ds-swatch-fill: ${esc(shade.swatch)};${shade.edge ? ` --ds-swatch-edge: ${esc(shade.edge)};` : ''}" aria-hidden="true"></span>`
        : '<span class="qd-row__no-swatch" aria-hidden="true"></span>';
      const chevron =
        '<svg class="qd-row__chevron" aria-hidden="true" focusable="false" width="8" height="5" viewBox="0 0 8 5" fill="none" stroke="currentColor" stroke-width="1"><path d="M.5.5L4 4 7.5.5"/></svg>';
      const sizeControl = several
        ? `<button type="button" class="qd-row__size" data-sofsy-track="qd.row.size_open.tap" data-sofsy-track-value="${esc(row.size)}" data-qd-size aria-expanded="false" aria-label="${esc(fill(s.size_button, { shade: shade.name, size: row.size }))}"><span class="qd-row__size-words">${esc(row.size)}</span>${chevron}<i class="qd-row__size-tap" aria-hidden="true"></i></button>`
        : `<span class="qd-row__size qd-row__size--fixed"><span class="qd-row__size-words">${esc(row.size)}</span></span>`;
      const notify = sold
        ? `<button type="button" class="qd-row__notify" data-sofsy-track="qd.row.notify.tap" data-sofsy-track-value="${esc(row.size)}" data-qd-notify>${esc(s.notify)}<i class="ds-tap" aria-hidden="true"></i></button>`
        : '';
      // #63 low-stock line: "Only N left" in red after the size when that size has 1 to the threshold units.
      const left = sold ? 0 : this.lowStock(row);
      const low = left > 0 && s.low_stock ? `<span class="qd-row__low">${esc(fill(s.low_stock, { n: left }))}</span>` : '';
      if (low) this.noteLowStock(row, left);
      return `<div class="qd-row${sold ? ' qd-row--sold' : ''}" role="listitem" data-qd-row="${index}" data-sofsy-track-product="${esc(shade.id)}" data-sofsy-track-shade="${esc(shade.name)}">
  <div class="qd-row__main" role="group" aria-label="${esc(this.rowLabel(row))}">
    ${swatch}
    <span class="qd-row__text">
      <span class="qd-row__name">${esc(shade.name)}</span>
      <span class="qd-row__sizeline">${sizeControl}${notify}${low}</span>
    </span>
    <span class="ds-stepper qd-row__stepper${sold ? ' ds-stepper--sold' : ''}">
      <button type="button" class="ds-stepper__btn" data-sofsy-track="qd.row.qty_minus.tap" data-qd-step="-1" aria-label="${esc(fill(s[`fewer_${word}`], { shade: shade.name }))}"${st.minusOff ? ' aria-disabled="true"' : ''}>&minus;<i class="ds-tap" aria-hidden="true"></i></button>
      <span class="ds-stepper__value"><span class="qd-xf" data-qd-value><span class="qd-xf__layer">${row.qty}</span></span></span>
      <button type="button" class="ds-stepper__btn" data-sofsy-track="qd.row.qty_plus.tap" data-qd-step="1" aria-label="${esc(fill(s[`more_${word}`], { shade: shade.name }))}"${st.plusOff ? ' aria-disabled="true"' : ''}>+<i class="ds-tap" aria-hidden="true"></i></button>
    </span>
  </div>
  <div class="qd-row__space" data-qd-space></div>
  <div class="qd-row__pills" role="radiogroup" aria-label="${esc(fill(s.size_group, { shade: shade.name }))}" data-qd-pills hidden></div>
</div>`;
    }

    renderRows() {
      this.list.innerHTML = this.rows.map((row, index) => this.rowHTML(row, index)).join('');
    }

    rowEl(index) {
      return this.list.querySelector(`[data-qd-row="${index}"]`);
    }

    // Re-draw one row in place (SR2 size change; Q-19 ungreying). Its position never changes while the drawer is open.
    redrawRow(index) {
      const old = this.rowEl(index);
      if (!old) return null;
      const holder = document.createElement('div');
      holder.innerHTML = this.rowHTML(this.rows[index], index);
      const fresh = holder.firstElementChild;
      old.replaceWith(fresh);
      return fresh;
    }

    // The steppers' enabled states and the row names for screen readers, after any change.
    refreshControls() {
      this.rows.forEach((row, index) => {
        const el = this.rowEl(index);
        if (!el) return;
        const st = this.stepperState(row);
        const minus = el.querySelector('[data-qd-step="-1"]');
        const plus = el.querySelector('[data-qd-step="1"]');
        [
          [minus, st.minusOff],
          [plus, st.plusOff],
        ].forEach(([button, off]) => {
          if (!button) return;
          if (off) button.setAttribute('aria-disabled', 'true');
          else button.removeAttribute('aria-disabled');
        });
        el.querySelector('.qd-row__main')?.setAttribute('aria-label', this.rowLabel(row));
      });
      const empty = this.total() === 0;
      this.addButton.disabled = empty || this.busy;
    }

    // Crossfade a figure in place (opacity only): the old copy fades out while the new one fades in, in the same
    // grid cell, so nothing moves and nothing goes blank.
    crossfade(slot, html, key, duration, delay, animate) {
      if (!slot) return;
      const layers = Array.from(slot.querySelectorAll(':scope > .qd-xf__layer:not(.qd-xf--out)'));
      const current = layers[layers.length - 1];
      if (current && current.dataset.key === key) return;
      const layer = document.createElement('span');
      layer.className = 'qd-xf__layer';
      layer.dataset.key = key;
      layer.innerHTML = html;
      if (!animate || !current || !this.isOpen) {
        slot.replaceChildren(layer);
        return;
      }
      const ms = motion(duration);
      layers.forEach((old) => {
        old.classList.add('qd-xf--out');
        old.setAttribute('aria-hidden', 'true');
        old.style.animationDuration = `${ms}ms`;
        old.style.animationDelay = `${delay}ms`;
        setTimeout(() => old.remove(), ms + delay + 50);
      });
      layer.classList.add('qd-xf--in');
      layer.style.animationDuration = `${ms}ms`;
      layer.style.animationDelay = `${delay}ms`;
      slot.appendChild(layer);
    }

    setValue(index, animate, delay = 0) {
      const el = this.rowEl(index);
      if (!el) return;
      const row = this.rows[index];
      this.crossfade(el.querySelector('[data-qd-value]'), String(row.qty), String(row.qty), tokenMs('--ds-dur-stepper-fade', 100), delay, animate);
    }

    updateFigures(animate, delay = 0) {
      const p = this.project();
      const fade = tokenMs('--ds-dur-fade', 150);
      const delivery = this.deliveryHTML(p);
      this.crossfade(this.deliveryEl, delivery || NBSP, delivery || 'none', fade, delay, animate);
      // Nothing chosen (every row at 0: Q-18, her shade sold out in her size): no "0 USD". The Round 6 drawer card has
      // no zero state (its drawer never empties), so the figures are blank with their space kept, as the delivery
      // line above, and the first pair fades its total in; Add to Bag stays disabled (refreshControls).
      const empty = p.pairs === 0;
      this.crossfade(this.totalEl, empty ? NBSP : esc(this.money(p.total)), empty ? 'none' : String(p.total), fade, delay, animate);
      this.querySelector('[data-qd-totals]')?.classList.toggle('is-empty', empty);
      const per = this.perText(p);
      this.crossfade(this.perEl, esc(per), per, fade, delay, animate);
      this.updateCts(animate, delay);
      this.refreshControls();
      return p;
    }

    // Complete the Set's link: shown, fading out IN PLACE (its box keeps its size), or hidden with its space kept.
    updateCts(animate, delay = 0) {
      if (!this.ctsSlotOn || !this.ctsLink) return;
      const show = this.ctsAvailable();
      const label = fill(this.strings.cts, { size: this.herSize() });
      this.ctsLink.setAttribute('aria-label', label);
      if (show === this.ctsShown) return;
      this.ctsShown = show;
      const ms = motion(tokenMs('--ds-dur-fade', 150));
      clearTimeout(this.ctsTimer);
      this.ctsSlot.classList.remove('is-entering', 'is-leaving');
      this.ctsSlot.style.animationDuration = `${ms}ms`;
      this.ctsSlot.style.animationDelay = `${delay}ms`;
      if (show) {
        this.ctsSlot.classList.remove('is-gone');
        this.ctsLink.removeAttribute('tabindex');
        this.ctsLink.removeAttribute('aria-hidden');
        if (animate && this.isOpen) this.ctsSlot.classList.add('is-entering');
      } else {
        this.ctsLink.setAttribute('tabindex', '-1');
        this.ctsLink.setAttribute('aria-hidden', 'true');
        if (animate && this.isOpen) {
          this.ctsSlot.classList.add('is-leaving');
          this.ctsTimer = setTimeout(() => {
            this.ctsSlot.classList.remove('is-leaving');
            this.ctsSlot.classList.add('is-gone');
          }, ms + delay);
        } else {
          this.ctsSlot.classList.add('is-gone');
        }
      }
    }

    announce(text) {
      if (!this.liveEl || !text) return;
      this.liveEl.textContent = '';
      clearTimeout(this.liveTimer);
      this.liveTimer = setTimeout(() => {
        this.liveEl.textContent = text;
      }, 60);
    }

    summary(p) {
      return [p.pairs > 0 ? this.money(p.total) : '', p.perPair != null ? this.perText(p) : '', this.deliveryText(p)].filter(Boolean).join('. ');
    }

    // #63 A8 (Ben): "2 pairs already in your bag" in grey, left, on the per-pair line (no extra line), replacing
    // "with your bag": the ladder units already in the bag, which the price per pair is pooled with. Only when there
    // are some and this style is on a ladder. Set when the drawer opens (and again only if the bag turns out to have
    // changed elsewhere), so the band never moves while she taps.
    syncWithBag() {
      const bagUnits = ((this.bag && this.bag.lines) || []).reduce((sum, line) => sum + (line.ladder_unit ? Number(line.quantity) || 0 : 0), 0);
      const show = bagUnits > 0 && this.data.shades.some((shade) => shade.unit);
      if (show) {
        const s = this.strings;
        const template = this.data.pair
          ? bagUnits === 1 ? s.in_bag_pair_one : s.in_bag_pair_other
          : bagUnits === 1 ? s.in_bag_piece_one : s.in_bag_piece_other;
        this.withBagEl.textContent = String(template || '').replace('%n%', String(bagUnits));
      }
      this.withBagEl.hidden = !show;
    }

    /* ----- H5: the list's height in rows ----- */

    fitList() {
      if (!this.list || !this.rows.length) return;
      const first = this.list.querySelector('.qd-row__main');
      const pitch = first ? first.getBoundingClientRect().height : 56;
      const n = this.rows.length;
      this.list.style.height = `${n * pitch}px`;
      const chrome = this.sheet.getBoundingClientRect().height - n * pitch;
      const visible = window.innerHeight || document.documentElement.clientHeight;
      let rowsMax = 5.5;
      while (chrome + rowsMax * pitch > 0.8 * visible && rowsMax > 1.5) rowsMax -= 1;
      const height = Math.min(n * pitch, Math.round(rowsMax * pitch));
      this.list.style.height = `${height}px`;
      this.list.classList.toggle('is-scrolling', n * pitch > height);
    }

    /* ----- open / close ----- */

    open({ from = 'atb', opener = null } = {}) {
      if (!this.data || !MQ.matches) return false;
      if (this.isOpen) return true;
      if (pendingBack) {
        // our own Back from the last close has not landed yet: open right after it, so it cannot close this one
        this.reopen = { from, opener };
        return true;
      }
      this.from = from;
      this.opener = opener;
      clearTimeout(this.rungTimer);
      this.rungTimer = 0;
      this.bag = readBag();
      this.buildRows(from === 'cts' ? 'cts' : 'atb');

      // The Complete the Set slot is decided once per open (so the layout never changes while she taps): a set with
      // at least `min` pieces in stock, each in its row's size, and at least one of them not in the bag yet (#63, Ben
      // 3 Oct: with every set shade in the bag, at any size, there is nothing to complete).
      const min = Number(this.data.set && this.data.set.min) || 2;
      this.ctsSlotOn = !!this.ctsLink && this.inStockSetRows().length >= min && this.missingSetRows().length > 0;
      this.ctsSlot.hidden = !this.ctsSlotOn;
      this.ctsSlot.classList.remove('is-gone', 'is-leaving', 'is-entering');
      clearTimeout(this.ctsTimer);
      this.ctsShown = null;

      // #63 (Ben swapped the two): Complete the Set is top left, on the X line, in every market; the delivery line
      // (US only) is bottom left, on the total's line (snippets/qty-drawer.liquid). Both are fixed for the open, so
      // nothing moves while she taps.
      const p0 = this.project();
      this.classList.toggle('qd--us', p0.isUs);
      this.classList.toggle('qd--set', this.ctsSlotOn);
      this.deliveryEl.hidden = !p0.isUs;
      this.syncWithBag();

      this.renderRows();
      this.clearError();
      this.hidePageError();
      this.updateFigures(false);

      this.hidden = false;
      this.classList.remove('is-closing');
      this.isOpen = true;
      lockPage();
      this.fitList();
      this.list.scrollTop = 0;
      this.scrollLine?.classList.remove('is-on');
      void this.sheet.offsetHeight; // start the slide from below
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.sheet.focus({ preventScroll: true });

      try {
        window.history.pushState({ [HISTORY_KEY]: true }, '');
        this.pushed = true;
      } catch (_) {
        this.pushed = false;
      }

      this.announce(this.summary(p0));
      this.refreshIfStale();
      this.stats = { last: 'none', errors: new Set() }; // qd.close's last_action, qd.error.view's reasons: per open
      track('qty_drawer_opened', { source: from });
      return true;
    }

    // how: close (the X) | scrim (the dimmed page) | escape | back (the phone's Back) | other (the width grew past
    // 1024 px, the page came back from the back-forward cache, SofsyQtyDrawer.close()); an add that closes it is
    // 'added' whatever is passed. reason 'adding' (zao#617): the Add tap closes it before Shopify has answered, so
    // qd.close is sent when the answer comes (settleOpenAdd), and her choices are kept until it has worked.
    close({ reason = 'dismiss', focus = true, fromHistory = false, how = 'other' } = {}) {
      if (!this.isOpen) return;
      if (reason !== 'adding') this.trackClose(reason === 'added' || reason === 'partial' ? 'added' : how);
      this.closePills(false);
      this.isOpen = false;
      if (reason === 'added') {
        this.saved = null;
      } else {
        this.saved = new Map(this.rows.map((row) => [row.shade.id, { size: row.size, custom: row.custom, qty: row.qty }]));
      }
      this.storeSaved();
      this.classList.remove('is-open');
      this.classList.add('is-closing');
      releaseLock();
      const ms = motion(tokenMs('--ds-dur-sheet-out', 160));
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        if (this.isOpen) return;
        this.classList.remove('is-closing');
        this.hidden = true;
      }, ms + 20);

      if (this.pushed && !fromHistory && window.history.state && window.history.state[HISTORY_KEY]) {
        pendingBack = true;
        clearTimeout(backTimer);
        backTimer = setTimeout(backLanded, 600); // a browser that never fires popstate must not block the next open
        window.history.back();
      }
      this.pushed = false;

      if (focus) {
        let target = this.opener;
        if (!target || !target.isConnected || getComputedStyle(target).visibility === 'hidden') {
          target = document.querySelector('#main-product .product-form__submit_main');
        }
        try {
          target && target.focus({ preventScroll: true });
        } catch (_) {
          /* not focusable */
        }
      }
    }

    // qd.close {how, added, shades, units, last_action}: once per open (close() returns early when it is not open).
    // shades = rows above 0, units = the pairs in them, last_action = her last step in the drawer (stepper, size,
    // notify, cts, or none).
    trackClose(how) {
      try {
        const rows = (this.rows || []).filter((row) => row.qty > 0);
        track('qd.close', {
          how,
          added: how === 'added',
          shades: rows.length,
          units: rows.reduce((sum, row) => sum + (Number(row.qty) || 0), 0),
          last_action: (this.stats && this.stats.last) || 'none',
        });
      } catch (_) {
        /* tracking never stops the drawer closing */
      }
    }

    noteAction(action) {
      if (this.stats) this.stats.last = action;
    }

    // GET /cart.js on each open: if the bag changed somewhere else (another tab, a restored page), re-render the bag
    // from the server and redo the figures with the fresh state.
    refreshIfStale() {
      const ci = cartItems();
      if (!ci || typeof ci.getCart !== 'function' || typeof ci.refreshBag !== 'function') return;
      const shown = this.bag;
      ci.getCart()
        .then((cart) => {
          const same =
            shown &&
            shown.item_count === cart.item_count &&
            shown.total_price === cart.total_price &&
            Array.isArray(shown.lines) &&
            shown.lines.length === cart.items.length &&
            shown.lines.every((line, i) => line.key === cart.items[i].key && line.quantity === cart.items[i].quantity);
          if (same) return null;
          return ci.refreshBag(cart).then(() => {
            if (!this.isOpen || this.busy) return;
            this.bag = readBag();
            this.rows.forEach((row) => {
              row.qty = Math.min(row.qty, this.cap(row));
            });
            this.rows.forEach((row, index) => this.setValue(index, false));
            this.syncWithBag();
            this.updateFigures(true);
            this.fitList();
          });
        })
        .catch(() => {
          /* the figures stay on the bag state the page already had */
        });
    }

    /* ----- taps inside the drawer ----- */

    onClick(event) {
      const t = event.target instanceof Element ? event.target : null;
      if (!t) return;

      // SR2: a tap anywhere outside the open row's pills and its size button closes them with no change.
      if (this.openRow != null) {
        const openEl = this.rowEl(this.openRow);
        const inside = openEl && (t.closest('[data-qd-pills]') === openEl.querySelector('[data-qd-pills]') || t.closest('[data-qd-size]') === openEl.querySelector('[data-qd-size]'));
        if (!inside) this.closePills(true);
      }

      const closer = t.closest('[data-qd-close]');
      if (closer) {
        event.preventDefault();
        this.close({ how: closer.classList.contains('qd__dim') ? 'scrim' : 'close' });
        return;
      }

      const step = t.closest('[data-qd-step]');
      if (step) {
        event.preventDefault();
        if (step.getAttribute('aria-disabled') === 'true') return;
        const rowEl = step.closest('[data-qd-row]');
        this.step(Number(rowEl.dataset.qdRow), Number(step.dataset.qdStep));
        return;
      }

      const size = t.closest('[data-qd-size]');
      if (size) {
        event.preventDefault();
        const index = Number(size.closest('[data-qd-row]').dataset.qdRow);
        if (this.openRow === index) this.closePills(true);
        else this.openPills(index, event.detail === 0);
        return;
      }

      const pill = t.closest('[data-qd-pill]');
      if (pill) {
        event.preventDefault();
        const index = Number(pill.closest('[data-qd-row]').dataset.qdRow);
        if (pill.getAttribute('aria-disabled') === 'true') {
          // A sold-out size chooses nothing; the tap is still a size tap (size_selected, in_stock false).
          this.trackSize(index, pill.dataset.qdPill, false);
          return;
        }
        this.chooseSize(index, pill.dataset.qdPill);
        return;
      }

      const notify = t.closest('[data-qd-notify]');
      if (notify) {
        event.preventDefault();
        const row = this.rows[Number(notify.closest('[data-qd-row]').dataset.qdRow)];
        const api = window.SofsyNotify;
        this.noteAction('notify');
        track('drawer_notify_tapped', { shade: row.shade.name, size: row.size, place: 'drawer', product_id: row.shade.id, variant_id: row.variant && row.variant.id });
        if (!api || typeof api.open !== 'function' || !api.open({ variantId: row.variant.id, size: row.size, shade: row.shade.name, opener: notify })) {
          console.warn('qty-drawer: the notify sheet did not open for variant', row.variant && row.variant.id);
        }
        return;
      }

      if (t.closest('[data-cts-link="drawer"]')) {
        event.preventDefault();
        if (!this.ctsAvailable()) return;
        track('complete_set_drawer_tapped', { place: 'drawer' });
        this.completeTheSet();
        return;
      }

      if (t.closest('[data-qd-add]')) {
        event.preventDefault();
        this.add();
      }
    }

    step(index, delta) {
      const row = this.rows[index];
      if (!row || this.busy) return;
      const st = this.stepperState(row);
      if ((delta < 0 && st.minusOff) || (delta > 0 && st.plusOff)) return;
      this.noteRungBefore();
      this.noteAction('stepper');
      row.qty += delta;
      this.scheduleRung(row);
      this.clearError();
      this.setValue(index, true);
      const p = this.updateFigures(true);
      this.announce(`${this.rowLabel(row)}. ${this.summary(p)}`);
      // Every stepper tap, not debounced (taxonomy v2.0, zao#455): the rung event above only sees the rung changing.
      track('qd.row.qty_change', {
        shade: row.shade.name,
        size: row.size,
        from: row.qty - delta,
        to: row.qty,
        drawer_pairs: p && Number.isFinite(p.pairs) ? p.pairs : null,
        pairs_total: p && Number.isFinite(p.pooled) ? p.pooled : null, // the drawer's plus the bag's (the rung's count)
        product_id: row.shade.id,
        variant_id: row.variant && row.variant.id
      });
    }

    /* ----- quantity_rung_selected: the Indulgence Privilege rung a burst of stepper taps lands on ----- */

    // The rung a row's ladder family is on at the pooled units: 1 while the privilege does not apply (fewer than 2
    // pooled units, or fewer than 2 eligible); else the ladder's rung at P, every rung past the last price change read
    // as that rung (the panel's last row, "4 pairs", covers 5 and more). With the price per pair she is shown for that row
    // (the projection above) and its saving, in major units. null for a row with no ladder (a garter belt).
    rungOf(row, p) {
      if (!row || !row.shade || !row.shade.unit || !row.variant) return null;
      const ladder = this.ladders && this.ladders[row.shade.ladder];
      if (!ladder || ladder[0] == null) return null;
      let level = 1;
      if (p.qualifies) {
        level = Math.min(p.pooled, ladder.length);
        while (level > 1 && ladder[level - 1] == null) level -= 1;
        while (level > 1 && ladder[level - 1] === ladder[level - 2]) level -= 1;
      }
      const price = Number(row.variant.price) || 0;
      let unit = price;
      if (p.qualifies) {
        unit = p.isUs ? Math.max(0, price - rungOff(ladder, p.pooled)) : Math.max(0, Math.round(price * rungShare(ladder, p.pooled)));
      }
      return { family: row.shade.ladder, level, pairs: p.pooled, rung_price: unit / 100, saving_per_pair: (price - unit) / 100 };
    }

    // The rung of every family in the drawer, taken before the first tap of a burst.
    noteRungBefore() {
      if (this.rungTimer) return; // a burst is running: keep the rung it started from
      const p = this.project();
      const levels = new Map();
      this.rows.forEach((row) => {
        const rung = this.rungOf(row, p);
        if (rung && !levels.has(rung.family)) levels.set(rung.family, rung.level);
      });
      this.rungBefore = levels;
    }

    // 600 ms after the last stepper tap: one quantity_rung_selected if the burst moved her onto another rung.
    scheduleRung(row) {
      clearTimeout(this.rungTimer);
      this.rungTimer = setTimeout(() => {
        this.rungTimer = 0;
        try {
          const rung = this.rungOf(row, this.project());
          if (!rung || (this.rungBefore && this.rungBefore.get(rung.family) === rung.level)) return;
          track('quantity_rung_selected', {
            pairs: rung.pairs,
            rung_price: rung.rung_price,
            saving_per_pair: rung.saving_per_pair,
            family: rung.family,
            product_id: row.shade.id,
            variant_id: row.variant.id,
          });
        } catch (_) {
          /* tracking never breaks the drawer */
        }
      }, RUNG_DEBOUNCE_MS);
    }

    completeTheSet() {
      this.noteAction('cts');
      const changed = this.applyCts();
      if (!changed.length) return;
      this.clearError();
      const stagger = tokenMs('--ds-stagger', 40);
      const ordered = this.rows.filter((row) => changed.includes(row));
      ordered.forEach((row, i) => this.setValue(this.rows.indexOf(row), true, REDUCED.matches ? 0 : i * stagger));
      const delay = REDUCED.matches ? 0 : (ordered.length - 1) * stagger + tokenMs('--ds-dur-stepper-fade', 100);
      // focus must not stay on a link that is about to fade out
      if (document.activeElement === this.ctsLink) this.sheet.focus({ preventScroll: true });
      const p = this.updateFigures(true, delay);
      const added = ordered.filter((row) => row.prev === 0).map((row) => row.shade.name);
      const names = added.length > 1 ? `${added.slice(0, -1).join(', ')}${this.strings.and || ' and '}${added[added.length - 1]}` : added[0] || '';
      this.announce([names ? fill(this.strings.added, { shades: names }) : '', `${this.countText(p.pairs)}, ${this.money(p.total)}`].filter(Boolean).join(' '));
    }

    /* ----- SR2: the size pills inside a row ----- */

    openPills(index, byKeyboard) {
      this.closePills(false);
      const row = this.rows[index];
      const el = this.rowEl(index);
      if (!row || !el) return;
      const s = this.strings;
      const pills = el.querySelector('[data-qd-pills]');
      const space = el.querySelector('[data-qd-space]');
      const button = el.querySelector('[data-qd-size]');
      pills.innerHTML = row.shade.variants
        .map((v) => {
          const on = v.size === row.size;
          const out = !v.available || !(Number(v.max) > 0);
          const label = out ? fill(s.size_sold, { shade: row.shade.name, size: v.size }) : v.size;
          return `<button type="button" class="qd-pill" role="radio" data-sofsy-track="qd.row.size.tap" data-sofsy-track-value="${esc(v.size)}" data-sofsy-track-variant="${esc(v.id)}" data-qd-pill="${esc(v.size)}" aria-checked="${on}" tabindex="${on ? '0' : '-1'}" aria-label="${esc(label)}"${out ? ' aria-disabled="true"' : ''}><span class="ds-pill ds-pill--compact${on ? ' ds-pill--chosen' : ''}${out ? ' ds-pill--sold ds-sold-diagonal' : ''}"><span class="ds-pill__words">${esc(v.size)}</span></span><i class="qd-pill__tap" aria-hidden="true"></i></button>`;
        })
        .join('');
      // left-aligned under the size words (Ben), a token below them
      const line = el.querySelector('.qd-row__sizeline');
      const rowBox = el.getBoundingClientRect();
      const lineBox = line.getBoundingClientRect();
      const above = parseFloat(getComputedStyle(el).getPropertyValue('--qd-pills-above')) || 8;
      const below = parseFloat(getComputedStyle(el).getPropertyValue('--qd-pills-below')) || 16;
      const main = el.querySelector('.qd-row__main').getBoundingClientRect().height;
      pills.style.top = `${lineBox.bottom - rowBox.top + above}px`;
      pills.style.left = `${lineBox.left - rowBox.left}px`;
      pills.hidden = false;
      // A10: every pill as wide as the widest (S no narrower than 2XL); measured now they are laid out
      pills.style.removeProperty('--qd-pill-w');
      const widest = Math.max(0, ...Array.from(pills.querySelectorAll('.ds-pill'), (p) => p.getBoundingClientRect().width));
      if (widest) pills.style.setProperty('--qd-pill-w', `${Math.ceil(widest)}px`);
      const grow = Math.max(0, lineBox.bottom - rowBox.top + above + pills.getBoundingClientRect().height + below - main);
      el.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      space.style.height = `${grow}px`;
      this.openRow = index;
      track('drawer_size_tapped', { shade: row.shade.name, size: row.size, product_id: row.shade.id, variant_id: row.variant && row.variant.id });
      // keep the open pills in view inside the list
      setTimeout(() => {
        const list = this.list.getBoundingClientRect();
        const bottom = el.getBoundingClientRect().bottom;
        if (bottom > list.bottom) this.list.scrollBy({ top: bottom - list.bottom, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }, motion(tokenMs('--ds-dur-fade', 150)));
      if (byKeyboard) pills.querySelector('[aria-checked="true"]')?.focus({ preventScroll: true });
    }

    closePills(animate, focusButton = false) {
      if (this.openRow == null) return;
      const el = this.rowEl(this.openRow);
      this.openRow = null;
      if (!el) return;
      const pills = el.querySelector('[data-qd-pills]');
      const space = el.querySelector('[data-qd-space]');
      const button = el.querySelector('[data-qd-size]');
      el.classList.remove('is-open');
      button?.setAttribute('aria-expanded', 'false');
      space.style.height = '0px';
      const done = () => {
        if (!el.classList.contains('is-open')) {
          pills.hidden = true;
          pills.innerHTML = '';
        }
      };
      if (animate) setTimeout(done, motion(tokenMs('--ds-dur-fade', 150)));
      else done();
      if (focusButton) button?.focus({ preventScroll: true });
    }

    // size_selected {size, variant_id, in_stock, place: 'drawer', changed_from_default}: a row's default size is the
    // page's size (every row follows it until she picks another one for that row).
    trackSize(index, size, inStock) {
      const row = this.rows[index];
      if (!row) return;
      const variant = this.variantOf(row.shade, size);
      this.noteAction('size');
      track('size_selected', {
        size,
        variant_id: variant ? variant.id : null,
        product_id: row.shade.id,
        in_stock: !!inStock,
        place: 'drawer',
        changed_from_default: size !== this.herSize(),
      });
    }

    chooseSize(index, size) {
      const row = this.rows[index];
      if (!row) return;
      const variant = this.variantOf(row.shade, size);
      if (!variant) return;
      this.trackSize(index, size, true);
      const wasSold = this.soldOut(row);
      if (size !== row.size) {
        row.size = size;
        row.variant = variant;
        row.custom = true;
        row.qty = Math.min(row.qty, this.cap(row));
      }
      this.closePills(false);
      const fresh = this.redrawRow(index);
      if (fresh && wasSold !== this.soldOut(row)) fresh.classList.add('qd-row--fresh');
      fresh?.querySelector('[data-qd-size]')?.focus({ preventScroll: true });
      const p = this.updateFigures(true);
      this.announce(`${this.rowLabel(row)}. ${this.summary(p)}`);
    }

    /* ----- the add ----- */

    // reason (qd.error.view, once per distinct reason per open): from the code path that shows the line, never from
    // its words: network (no answer), stock_limit (Shopify refused the quantity: a 422), other (no cart script, any
    // other refusal). The drawer never shows a line for a missing size or a sold-out row, so no_size and sold_out
    // (spec 3.7) have no code path here.
    showError(text, reason, extra) {
      if (!this.errorEl) return;
      this.errorEl.textContent = text || '';
      this.errorEl.hidden = !text;
      if (text && reason && this.stats && !this.stats.errors.has(reason)) {
        this.stats.errors.add(reason);
        track('qd.error.view', Object.assign({ reason }, extra || {}));
      }
    }

    clearError() {
      this.showError('');
    }

    pageErrorWrap() {
      return document.querySelector('#main-product product-form .product-form__error-message-wrapper');
    }

    hidePageError() {
      const wrap = this.pageErrorWrap();
      if (wrap && this.pageErrorShown) {
        wrap.hidden = true;
        this.pageErrorShown = false;
      }
    }

    // Unhide today's error wrapper with the same words: Clarity counts add_to_cart_failed from it.
    showPageError(text) {
      const wrap = this.pageErrorWrap();
      if (!wrap || !text) return;
      const words = wrap.querySelector('.product-form__error-message');
      if (words) words.textContent = text;
      wrap.hidden = false;
      this.pageErrorShown = true;
    }

    add() {
      if (this.busy) return;
      const chosen = this.rows.filter((row) => row.qty > 0 && row.variant);
      const items = chosen.map((row) => ({ id: row.variant.id, quantity: row.qty }));
      if (!items.length) return;
      const ci = cartItems();
      if (!ci || typeof ci.addItems !== 'function') {
        this.showError((window.cartStrings && window.cartStrings.error) || '', 'other');
        return;
      }
      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');
      this.clearError();
      this.hidePageError();
      const source = this.from === 'cts' ? 'cts_line' : 'drawer';
      // zao#617: the bag opens NOW, showing what is being added, instead of after Shopify's answer (perf.bag.open
      // median 1,499 ms before). The add itself is the same single addItems call; its answer settles the bag.
      const pending = this.beginOpenAdd(ci, chosen);
      if (pending) {
        // Nothing here may stop the add being sent: the add's answer is what settles the pending bag.
        try {
          this.close({ reason: 'adding' });
        } catch (error) {
          console.error('The quantity drawer could not close before the add:', error);
        }
        try {
          ci.viewDrawer();
        } catch (error) {
          console.error('The bag could not be opened before the add:', error);
        }
      }
      ci.addItems(items, { source }).then((result) => {
        this.busy = false;
        this.addButton.removeAttribute('aria-busy');
        if (pending) {
          this.settleOpenAdd(ci, pending, result);
          return;
        }
        if (result && result.ok) {
          this.close({ reason: 'added' });
          ci.viewDrawer();
          return;
        }
        const words = (result && result.description) || (window.cartStrings && window.cartStrings.error) || '';
        if (result && result.cartChanged === true) {
          // Shopify added part of it (stock) and refused the rest: show her the real bag, and the sentence on the page.
          this.close({ reason: 'partial' });
          this.showPageError(words);
          ci.viewDrawer();
          return;
        }
        this.showError(words, result && result.network ? 'network' : result && result.status === 422 ? 'stock_limit' : 'other');
        this.showPageError(words);
        this.refreshControls();
        this.fitList();
        this.announce(words);
      });
    }

    // zao#617: draw the add into the bag before the request (assets/cart.js beginPendingAdd). null when the bag
    // cannot (an older cart.js, no bag, an add already pending): the add then runs as before, bag after the answer.
    beginOpenAdd(ci, chosen) {
      if (typeof ci.beginPendingAdd !== 'function' || typeof ci.endPendingAdd !== 'function' || typeof ci.viewDrawer !== 'function') {
        return null;
      }
      try {
        const nameEl = document.querySelector('#main-product .pdp-name-block__name');
        return ci.beginPendingAdd(
          chosen.map((row) => ({
            id: row.variant.id,
            quantity: row.qty,
            productId: row.shade.id,
            shade: row.shade.name || '',
            size: row.size || '',
          })),
          {
            name: nameEl ? nameEl.textContent.trim() : '',
            styleProducts: this.rows.map((row) => row.shade.id),
          }
        );
      } catch (_) {
        return null;
      }
    }

    // The bag is already open (zao#617): settle it with Shopify's answer. qd.close was held at the close (reason
    // 'adding') so it can say what really happened: 'added' for an add that worked or was partly kept (as before),
    // 'add_failed' (added:false) for a full refusal. Order as before: bag_items_added (cart.js, inside addItems),
    // then qd.close, then view_cart (held by sofsy-track.js until endPendingAdd says the add has settled).
    settleOpenAdd(ci, pending, result) {
      // Whatever happens here, the bag is settled last (finally): a throw must never leave it busy and pending.
      try {
        const words = (result && result.description) || (window.cartStrings && window.cartStrings.error) || '';
        if (result && result.ok) {
          this.trackClose('added');
          this.saved = null; // as a close after an add: her choices are not kept for the next open
          this.storeSaved();
        } else if (result && result.cartChanged === true) {
          // Shopify added part of it (stock) and refused the rest: the bag shows the real cart and the sentence.
          this.trackClose('added');
          this.saved = null;
          this.storeSaved();
          this.showPageError(words);
        } else {
          // A full refusal: her quantities stay for the next open (kept at the close), the sentence shows in the bag
          // (cart.js) and, as before, on the page, where Clarity's add_to_cart_failed counts it. qd.error.view keeps
          // its reasons, with in_bag:true because the drawer is closed and the words show in the bag (the drawer's
          // error line is set too, and cleared on the next open).
          this.trackClose('add_failed');
          this.showError(words, result && result.network ? 'network' : result && result.status === 422 ? 'stock_limit' : 'other', {
            in_bag: true,
          });
          this.showPageError(words);
        }
        this.refreshControls();
      } catch (error) {
        console.error('The quantity drawer could not finish its add:', error);
      } finally {
        ci.endPendingAdd(pending, result);
      }
    }
  }

  customElements.define('sofsy-qty-drawer', SofsyQtyDrawer);

  /* ---------- the page lock (the drawer owns its own; the bag and the old sheet use their own classes) ---------- */

  function lockPage() {
    document.documentElement.classList.add('sofsy-qd-lock');
  }
  function releaseLock() {
    document.documentElement.classList.remove('sofsy-qd-lock');
  }

  const drawer = () => document.querySelector('#main-product sofsy-qty-drawer') || document.querySelector('sofsy-qty-drawer');
  const openDrawer = () => {
    const d = drawer();
    return d && d.isOpen ? d : null;
  };

  /* ---------- what opens it: the page's buttons and the Complete the Set line (capture phase) ---------- */

  document.addEventListener(
    'click',
    (event) => {
      if (!MQ.matches) return;
      const t = event.target instanceof Element ? event.target : null;
      if (!t) return;

      const buttons = t.closest('#main-product .product-form__buttons.main');
      if (buttons) {
        const d = drawer();
        const notifyOnly = buttons.hasAttribute('data-pdp-notify');
        if (!notifyOnly && (!d || !d.data)) return; // no drawer on this page: today's add runs
        event.preventDefault();
        event.stopPropagation();
        const sticky = !!t.closest('.sticky-button-container');
        const opener = sticky
          ? buttons.querySelector('.sticky-button-container .product-form__submit')
          : buttons.querySelector('.product-form__submit_main');
        if (notifyOnly) {
          // SR-2: the drawer would have nothing to offer, so the buttons say "Notify me" and the tap asks to be told
          // when her shade is back. Not an Add to Bag tap and no drawer: no sticky_atc_tapped, no qty_drawer_opened.
          notifyHer(d, buttons, opener);
          return;
        }
        if (sticky) track('sticky_atc_tapped');
        d.open({ from: sticky ? 'sticky' : 'atb', opener });
        return;
      }

      const line = t.closest('#main-product [data-cts-link="page"]');
      if (line) {
        const d = drawer();
        if (!d || !d.data) return;
        event.preventDefault();
        event.stopPropagation();
        track('complete_set_line_tapped', { place: 'pdp' });
        d.open({ from: 'cts', opener: line });
      }
    },
    true
  );

  // SR-2: the notify sheet for her shade in her size: exactly the variant her own row's "Notify me" subscribes in the
  // drawer (G0), counted as that row's tap (drawer_notify_tapped, the same payload). Without the drawer's data, the
  // section's default (<product-form data-id>, Liquid pdp_default_or_first), with no size words.
  function notifyHer(d, buttons, opener) {
    let target = null;
    if (d && d.data) {
      const her = d.her();
      const variant = her ? d.variantOf(her, d.herSize()) || her.variants[0] || null : null;
      if (variant) target = { variantId: variant.id, size: variant.size, shade: her.name, productId: her.id };
    }
    if (!target) {
      const form = buttons.closest('product-form');
      target = { variantId: form ? form.dataset.id : null, size: '', shade: '', productId: null };
    }
    track('drawer_notify_tapped', { shade: target.shade, size: target.size, place: 'page', product_id: target.productId, variant_id: target.variantId });
    const api = window.SofsyNotify;
    if (!api || typeof api.open !== 'function' || !api.open({ variantId: target.variantId, size: target.size, shade: target.shade, opener })) {
      console.warn('qty-drawer: the notify sheet did not open for variant', target.variantId);
    }
  }

  // The page's two buttons say they open a dialog, at the widths where they do. SR-2: in notify-only mode
  // ([data-pdp-notify]) a button the server rendered disabled (no size in stock) is enabled at <= 1024 px, so
  // "Notify me" takes focus, Enter and VoiceOver as well as a tap (every click is still caught above: never a submit);
  // above 1024 px it is disabled again, desktop's "Select your size" as today. Only this file enables it, so before it
  // loads the button stays as the server drew it.
  function syncButtons() {
    document.querySelectorAll('#main-product .product-form__buttons.main .product-form__submit').forEach((button) => {
      if (MQ.matches) button.setAttribute('aria-haspopup', 'dialog');
      else button.removeAttribute('aria-haspopup');
      const notifyOnly = !!button.closest('[data-pdp-notify]');
      if (notifyOnly && MQ.matches && button.disabled) {
        button.disabled = false;
        button.dataset.pdpNotifyEnabled = '';
      } else if ((!notifyOnly || !MQ.matches) && 'pdpNotifyEnabled' in button.dataset) {
        button.disabled = true;
        delete button.dataset.pdpNotifyEnabled;
      }
    });
  }

  /* ---------- keyboard: Escape closes (the open pills first), Tab stays inside ---------- */

  const focusables = (root) =>
    Array.from(root.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')).filter(
      (el) => !el.disabled && !el.closest('[hidden]') && el.getAttribute('tabindex') !== '-1' && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'
    );

  document.addEventListener('keydown', (event) => {
    const d = openDrawer();
    if (!d) return;
    const active = document.activeElement;
    const inside = active === document.body || (active && d.contains(active));
    if (!inside) return; // the notify sheet (or anything above the drawer) has the keyboard

    if (event.key === 'Escape') {
      event.preventDefault();
      if (d.openRow != null) d.closePills(true, true);
      else d.close({ how: 'escape' });
      return;
    }

    // Tab and Shift+Tab move through the sheet's controls and wrap. Done here rather than left to the browser:
    // Safari's default Tab order skips plain buttons, so it would leave the sheet (measured in WebKit).
    if (event.key === 'Tab') {
      event.preventDefault();
      const items = focusables(d.sheet);
      if (!items.length) {
        d.sheet.focus();
        return;
      }
      const i = items.indexOf(active);
      let next;
      if (i < 0) next = event.shiftKey ? items[items.length - 1] : items[0];
      else next = items[(i + (event.shiftKey ? -1 : 1) + items.length) % items.length];
      next.focus();
      return;
    }

    // SR2 pills: a radio group, arrow keys move and choose
    const pill = active && active.closest && active.closest('[data-qd-pill]');
    if (pill && /^Arrow(Left|Right|Up|Down)$/.test(event.key)) {
      const group = Array.from(pill.parentElement.querySelectorAll('[data-qd-pill]:not([aria-disabled="true"])'));
      const i = group.indexOf(pill);
      const next = group[(i + (/Right|Down/.test(event.key) ? 1 : -1) + group.length) % group.length];
      if (next) {
        event.preventDefault();
        group.forEach((p) => p.setAttribute('tabindex', p === next ? '0' : '-1'));
        next.focus();
      }
    }
  });

  // Focus never wanders onto the page behind while the drawer is open (a screen reader's own navigation, a script);
  // a sheet opened ABOVE the drawer (the notify sheet, any other dialog) keeps its focus.
  document.addEventListener('focusin', (event) => {
    const d = openDrawer();
    const t = event.target;
    if (!d || !(t instanceof Element) || d.contains(t)) return;
    if (t.closest('modal-dialog, [role="dialog"], [aria-modal="true"], cart-items, #cart-drawer')) return;
    d.sheet.focus({ preventScroll: true });
  });

  /* ---------- Back closes it; our own history.back() is ignored ---------- */

  function backLanded() {
    pendingBack = false;
    clearTimeout(backTimer);
    const d = drawer();
    if (d && d.reopen) {
      const again = d.reopen;
      d.reopen = null;
      d.open(again);
    }
  }

  window.addEventListener('popstate', () => {
    if (pendingBack) {
      backLanded();
      return;
    }
    const d = openDrawer();
    if (d) d.close({ fromHistory: true, how: 'back' });
  });

  // A page restored from the back-forward cache must never come back locked.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const d = drawer();
    if (d && d.isOpen) d.close({ focus: false, fromHistory: true });
    releaseLock();
  });

  /* ---------- widths: above 1024 px there is no drawer ---------- */

  const onWidth = () => {
    syncButtons();
    const d = openDrawer();
    if (d && !MQ.matches) d.close({ focus: false });
  };
  if (typeof MQ.addEventListener === 'function') MQ.addEventListener('change', onWidth);
  else if (typeof MQ.addListener === 'function') MQ.addListener(onWidth);

  window.addEventListener('resize', () => {
    const d = openDrawer();
    if (d) d.fitList();
  });

  document.addEventListener('sectionReloadFinished', () => setTimeout(syncButtons, 0));
  syncButtons();

  window.SofsyQtyDrawer = Object.freeze({
    open: (options) => {
      const d = drawer();
      return d ? d.open(options || {}) : false;
    },
    close: () => {
      const d = openDrawer();
      if (d) d.close();
    },
    isOpen: () => !!openDrawer(),
  });
})();
